module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAfCAYAAABtYXSPAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADjSURBVFiF7dTRDYIwFIXhczoZHYMyDDIMMIZ1suOLEMVeFBMoJv0fadp8Ie0lVhrHsZLUAqiev0vqmqa5bNknqQOAtX20Fvq+v5BsrfXU4RZ+uc8CJTGfIIniGuBb0BvmB8hPpUAvmKMgFmjGHA1JgZgTsgQxN2SKpHe5EVOSWneGv/KoctPwyp2kjgAwDMMVG4bWDsUQgp+fdkZQDCF4YDH0MoBmCAC8vKbHQtwbkIK8YSYQSb/XxZZ0I+mXkCQGAOq6jntAPp1/mqEHFIxdwVgVjFXBWBWM1X9gnHPxQMf5ugOwjoM97Lc4fgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/layout/icon/icon-design.png
// module id = 5
// module chunks = 63